import React from 'react';
import { Link } from 'react-router-dom';
import { FiBox, FiMail, FiWifi, FiVideo } from 'react-icons/fi';
import { MdPets } from 'react-icons/md';
import { FaCreditCard } from 'react-icons/fa';
import { GiMeditation } from 'react-icons/gi';
import { IoSchoolOutline } from 'react-icons/io5';

interface QuickTool {
  icon: React.ReactNode;
  label: string;
  link: string;
}

const quickTools: QuickTool[] = [
  { icon: <FiBox size={40} />, label: 'Box', link: '/box' },
  { icon: <FaCreditCard size={40} />, label: 'CatCard', link: '/catcard' },
  { icon: <IoSchoolOutline size={40} />, label: 'Cat Courses', link: '/cat-courses' },
  { icon: <FiMail size={40} />, label: 'Email', link: '/email' },
  { icon: <FiWifi size={40} />, label: 'VPN', link: '/vpn' },
  { icon: <FiVideo size={40} />, label: 'Zoom', link: '/zoom' },
  { icon: <MdPets size={40} />, label: 'Campus Ready', link: '/campus-ready' },
  { icon: <GiMeditation size={40} />, label: 'Calm', link: '/calm' },
];

const QuickTools: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-uc-navy font-header uppercase tracking-wide">
          Quick Tools
        </h2>
        <button className="text-gray-600 hover:text-gray-800">
          <span className="text-2xl">−</span>
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4">
        {quickTools.map((tool, index) => (
          <Link
            key={index}
            to={tool.link}
            className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 transition-colors group"
          >
            <div className="text-uc-gold mb-2 group-hover:scale-110 transition-transform">
              {tool.icon}
            </div>
            <span className="text-sm text-gray-700 text-center">{tool.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickTools;
